<template>
  <v-container fluid>
    <v-row justify="center" no-gutters>
      <v-col cols="12" class="mt-16 w100">
        <v-img :src="logoImg" max-width="600" class="mx-auto"></v-img>
        <p class="text-center mt-5 text-h5 accent">Мы помогаем конкретным людям, у которых есть свои радости, истории и характер</p>
        <p class="mt-5 text-body-1">АНО "Ответ" — это организация, объединяющая неравнодушных людей, готовых оказать поддержку тем,
          кто оказался в сложной жизненной ситуации. Мы верим, что каждому человеку важно чувствовать заботу и поддержку, особенно тогда,
          когда человек не справляется самостоятельно.</p>
        <p class="mt-5 text-body-1">Цель нашей организации — оказывать всестороннюю поддержку тем,
          кто столкнулся с жизненными сложностями и нуждается в особенной поддержке.
          Наша главная цель заключается в создании комфортной среды, способствующей преодолению трудностей,
          улучшению условий жизни и возвращению уверенности в завтрашнем дне.</p>
        <p class="mt-5 text-body-1">Мы приглашаем вас присоединиться и стать частью нашего сообщества, где можно получить
          поддержку на своём пути к восстановлению и повышению качества повседневной жизни.</p>
        <v-btn class="align-center text-white ml-auto mr-auto d-block mt-5 accent-bg">
          <a href="https://qr.nspk.ru/AS2A005RR68CQSD39JVB59RUD13DLHI5?type=01&bank=100000000111&crc=5547"
             class="text-decoration-none text-white">Поддержать</a></v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OurProjects from "@/components/OurProjects.vue";

export default {
  components: {OurProjects},
  data: () => ({
    logoImg: require('../assets/logo.png'),
  })
}
</script>

<style scoped lang="sass">
@font-face
  font-family: 'Playpen'
  src: url('@/fonts/playpen.ttf') format('truetype')
  font-weight: normal
  font-style: normal
  font-display: swap
p
  text-indent: 35px
  font-family: 'Playpen', sans-serif !important
@media (max-width: 375px)
  .w100
    width: 100% !important
</style>